export const TIPPS_DE = {

        search : {
            title: 'Suche',
            content: [
                {
                    id: '1',
                    question: 'Wo finde ich die Suche?',
                    answer: 'Die Suche befindet sich auf der rechten Seite in der Toolbar.'
                },
                {
                    id: '2',
                    question: 'Was kann ich durchsuchen?',
                    answer: 'Sie können den gesamten Inhalt des litelloBooks durchsuchen. (Technisch ausgeschlossen sind derzeit Inhalte in Quizzen & Akkordeons.)'
                },
                {
                    id: '3',
                    question: 'Wie springe ich an die richtige Stelle im litelloBook?',
                    answer: 'Damit Sie die richtige Stelle im litelloBook finden, klicken Sie die Pinnadel unter dem Suchergebnis.'
                }
            ]
    },
    markings : {
        title: 'Markierungen',
        content: [
            {
                id: '1',
                question: 'Wie mache ich eine Markierung und Notiz?',
                answer: 'Markieren Sie den Text wie gewohnt mit dem Finger oder dem Mauszeiger und wählen Sie über das erscheinende Markierungs-Menü die Farbe aus. Zusätzlich haben Sie die Möglichkeit sich eine Notiz für die Markierung zu machen.'
            },
            {
                id: '2',
                question: 'Wo finde ich meine Markierungen und Notizen? ',
                answer: 'Ihre Markierungen öffnen Sie auf der rechten Seite in der Toolbar.'
            },
            {
                id: '3',
                question: 'Wie bearbeite ich eine Notiz?',
                answer: 'Um eine Notiz zu bearbeiten klicken Sie auf die Markierung und wählen im Markierungs-Menü den Punkt „Notiz“ oder Sie gehen über die Toolbar auf ihre Markierungen und bearbeiten sie dort.'
            },
            {
                id: '4',
                question: 'Wie kann ich eine Markierung oder Notiz löschen?',
                answer: 'Um eine Markierung zu löschen klicken Sie im Markierungs-Menü einfach auf den Mülleimer. Wenn Sie eine Notiz löschen möchten, müssen Sie diese bearbeiten und den Text entfernen.'
            }
        ]
    },
    downloads : {
        title: 'Downloads',
        content: [
            {
                id: '1',
                question: 'Wo finde ich die angehängten Downloads?',
                answer: 'Sofern im geöffneten litelloBook Downloads vorhanden sind, sehen Sie in der Toolbar auf der rechten Seite eine Büroklammer. Dort haben Sie einen Überblick über alle angehängten Downloads. Sie finden die Downloads außerdem innerhalb des litelloBooks an den passenden Stellen.'
            },
            {
                id: '2',
                question: 'Wie funktionieren die Downloads?',
                answer: 'Sie können die Dateien direkt herunterladen. Achtung: Es wird nicht überprüft ob Sie den Download bereits getätigt haben.'
            }
        ]
    }
}

export const TIPPS_EN = {

        search : {
            title: 'Search',
            content: [
                {
                    id: '1',
                    question: 'Where can I find the search?',
                    answer: 'The search is located on the right side in the toolbar.'
                },
                {
                    id: '2',
                    question: 'What can I search?',
                    answer: 'You can search the entire content of the litelloBook. (Technically excluded are currently contents in quizzes & accordions).'
                },
                {
                    id: '3',
                    question: 'How do I jump to the right place in litelloBook?',
                    answer: 'To help you find the right place in litelloBook, click the pin under the search result.'
                }
            ]
        },
        markings : {
            id: '1',
            title: 'Markings',
            content: [
                {
                    id: '1',
                    question: 'How do I make a mark and note?',
                    answer: 'Mark the text as usual with your finger or the mouse pointer and select the color via the marking menu that appears. In addition, you have the option to make a note for the marking.'
                },
                {
                    id: '2',
                    question: 'Where can I find my markers and notes?',
                    answer: 'You open your markers on the right side in the toolbar.'
                },
                {
                    id: '3',
                    question: 'How do I edit a note?',
                    answer: 'To edit a note click on the marker and select "Note" in the marker menu or go to your markers via the toolbar and edit them there.'
                },
                {
                    id: '4',
                    question: 'How can I delete a marker or note?',
                    answer: 'To delete a marker simply click on the trash can in the marker menu. If you want to delete a note, you need to edit it and remove the text.'
                }
            ]
        },
        downloads : {
            title: 'Downloads',
            content: [
                {
                    id: '1',
                    question: 'Where can I find the attached downloads?',
                    answer: 'If there are downloads in the opened litelloBook, you will see a paper clip in the toolbar on the right side. There you have an overview of all attached downloads. You will also find the downloads within the litelloBook at the appropriate places.'
                },
                {
                    id: '2',
                    question: 'How do the downloads work?',
                    answer: 'You can download the files directly. Attention: It will not be checked if you have already made the download.'
                }
            ]
        }
}